import React from 'react';
import { Col, Row } from '../../../lib/utils';
import EmptyClass from './EmptyClass';
import ClassDayCard from './ClassDayCard';

const ClassHistoryThisYear = ({
    thisYearList,
    searchText,
    thisYearFilterList,
    yearToggleState,
    onClickYearToggleBtn,
}: any) => {
    if (thisYearFilterList && thisYearFilterList.length === 0) {
        return (
            <Col style={{ width: 1192 }}>
                <EmptyClass />
            </Col>
        );
    }

    return (
        <Col style={{ width: 1192, gap: 12 }}>
            {thisYearList?.map((yearItem: any, yearIndex: number) => {
                const keys = Object.keys(yearItem);
                const monthKey = keys[0];
                const monthArr = yearItem[monthKey];

                let sumCount = 0;
                if (monthArr.length !== 0) {
                    for (let i = 0; i < monthArr.length; i++) {
                        const dayKeys = Object.keys(monthArr[i]);
                        const dayObject = monthArr[i][dayKeys[0]];
                        const filtered = searchText
                            ? dayObject.filter((e: any) => e.alias.includes(searchText))
                            : dayObject;
                        sumCount += filtered.length;
                    }
                }

                if (monthArr.length === 0 || sumCount === 0) return <div key={'y' + yearIndex} />;

                // toggleState === true → 펼쳐짐 (기본값은 false = 접힘)
                const isOpen = !!yearToggleState[yearIndex];

                return (
                    <Col key={'thisYearArr' + yearIndex} style={{ gap: 8 }}>
                        {/* 월 헤더 (토글 가능) — 컴팩트 */}
                        <Row
                            onClick={() => onClickYearToggleBtn(yearIndex)}
                            style={{
                                alignItems: 'center',
                                gap: 12,
                                padding: '10px 16px',
                                backgroundColor: '#F8FAFC',
                                border: '1px solid #E2E8F0',
                                borderRadius: 10,
                                cursor: 'pointer',
                                transition: 'background-color 0.15s',
                            }}
                        >
                            <span style={{ fontSize: 16, fontWeight: 800, color: '#2563EB' }}>
                                {monthKey}월
                            </span>
                            <span style={{ fontSize: 13, color: '#475569' }}>
                                총 <b style={{ color: '#2563EB', fontSize: 14 }}>{sumCount}</b>회 진행
                            </span>
                            <div style={{ flex: 1 }} />
                            <span
                                style={{
                                    fontSize: 12,
                                    fontWeight: 600,
                                    color: '#6B7280',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: 4,
                                }}
                            >
                                {isOpen ? '접기' : '펼치기'}
                                <span style={{ fontSize: 9, transform: isOpen ? 'rotate(180deg)' : 'none', transition: 'transform 0.2s' }}>
                                    ▼
                                </span>
                            </span>
                        </Row>

                        {/* 일별 카드 (펼쳐진 상태일 때만) */}
                        {isOpen && (
                            <Col style={{ gap: 8 }}>
                                {monthArr.map((monthItem: any, monthIndex: number) => {
                                    const dayKeys = Object.keys(monthItem);
                                    const dayObject = monthItem[dayKeys[0]];
                                    const dayTime = dayObject[0].startTime;
                                    const filteredList = searchText
                                        ? dayObject.filter((e: any) => e.alias.includes(searchText))
                                        : dayObject;

                                    if (!filteredList || filteredList.length === 0) {
                                        return <div key={monthIndex} />;
                                    }

                                    return (
                                        <ClassDayCard
                                            key={monthIndex + 'ThisYearDay'}
                                            date={dayTime}
                                            classes={filteredList}
                                            accentIdx={monthIndex}
                                        />
                                    );
                                })}
                            </Col>
                        )}
                    </Col>
                );
            })}
        </Col>
    );
};

export default ClassHistoryThisYear;
